import { render, staticRenderFns } from "./edutalk-information-general.vue?vue&type=template&id=6363c70d&scoped=true"
import script from "./edutalk-information-general.vue?vue&type=script&lang=js"
export * from "./edutalk-information-general.vue?vue&type=script&lang=js"
import style0 from "./edutalk-information-general.vue?vue&type=style&index=0&id=6363c70d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6363c70d",
  null
  
)

export default component.exports